import { AppThunk } from '../../../../../store/types';
import { ICaptionsItem, PlayerStates } from '../../../../../types/common';
import { PlayerController } from '../../../../../effects/player/manager/playerController';
import { CaptionsSelectionPopupActions } from '../../../../../store/captions-selection-popup/actions';
import { findVideoPhraseById, getTargetCaptions } from '../../../../../store/videos/selectors';
import { IPhraseSelectPreparatorSelectionInfo } from '../../../../../effects/phrase/utils/phrase-select-preparator';
import { getPlayerState, isHoverAutoPause } from '../../../../../store/general/selectors';
import { PhraseDetailsEffects } from '../../../../../effects/phrase-details/phrase-details-effects';
import { SelectionUtil } from '../../../../../../common/utils/selection-util';
import { SelectionPopupEffects } from '../../../../../effects/selectionPopupEffects';
import { EventsRouter } from '../../../../../../common/events/eventsRouter';
import { Events } from '../../../../../../common/events/types';
import { TargetCaptionsEffects } from '../../../AudioCaptions/TargetCaptions/effects/TargetCaptionsEffects';
import { CaptionsSelectionPopupSelectors } from '../../../../../store/captions-selection-popup/selectors';
import { ExtensionInstallChecker } from '../../../../../effects/extension-install-checker';
import { PlayerFactory } from '../../../../../effects/player/player-factory';
import { loadVideoEffect } from '../../../../../effects/video_effects';
import { getCurrentMovieKey } from '../../../../../store/current-video/selectors';
import { getActiveGroupId } from '../../../../../store/models/selectors';


export class TargetCaptionsEvents {

  public static onCaptionClick(
    index: number,
    caption: ICaptionsItem,
    wordIndex: number,
    ctrlKey: boolean,
    phraseId?: number,
    elementId?: string
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {

      if (phraseId || ctrlKey) {
        return TargetCaptionsEffects.selectCaption(index, caption, wordIndex, phraseId);
      }

      // if (phraseId) {
      //   const state = getState();
      //   const phrase = PhraseListSelectors.findPhraseById(state, phraseId);
      //   const group = getUserGroupById(state, phrase?.userGroupId);
      //   const targetLang = group && getGroupTargetLanguage(state, group) || null;
      //   if (group && targetLang) {
      //     const nativeLang = getGroupNativeLanguage(state, group);
      //     PhraseDetailsEffects.showFromSavedPhrase(targetLang, nativeLang, nativeLang, phrase.highlighted, phrase, true);
      //     dispatch(CaptionsSelectionPopupActions.setCurrentSelection({wordPhraseId: phrase.wordPhraseId, contextPhraseId: phrase.id}));
      //     dispatch(CaptionsSelectionPopupActions.setShow(true));
      //     dispatch(PhraseListActions.setPlayCaptionByPhraseId(phrase.id));
      //     PhraseEffects.seekPhrase(phrase);
      //     const note = getVideoPhraseNoteByPhraseId(state, phrase.id);
      //     if (note) {
      //       dispatch(PhraseListActions.setNotePopup(true));
      //     } else {
      //       PhraseNoteEffects.checkCloseNotePopup(phrase);
      //     }
      //     return;
      //   }
      // }

      const selectionInfo: IPhraseSelectPreparatorSelectionInfo = {
        text: caption.text.substring(wordIndex, wordIndex + 1),
        startCaptionIndex: index,
        endCaptionIndex: index,
        startPosition: wordIndex,
        endPosition: wordIndex + 1
      }

      const onPlay = async (): Promise<any> => {
        return PlayerController.getInstance().pausePlay(true)
      }
      await TargetCaptionsEffects.runSelectText(window.getSelection(), selectionInfo, elementId, false, true, onPlay);

    }
  }

  public static onCaptionDblClick(index: number, caption: ICaptionsItem) : AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      PlayerController.getInstance().playCaption(caption, true);
    }
  };



    public static onCaptionPlay(caption: ICaptionsItem, isPause: boolean): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (isPause) {
        PlayerController.getInstance().pause();
      } else {
        PlayerController.getInstance().playCaption(caption, true);
      }
    }
  }

  public static onCaptionMouseDown(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (getPlayerState(getState()) === PlayerStates.PLAYING) {
        PlayerController.getInstance().pause();
      }
    }
  }

  public static onMouseLeave(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (!isHoverAutoPause(getState())) return;
      PlayerController.getInstance().mouseLeave();
    }
  }

  public static onMouseEnter(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (!isHoverAutoPause(getState())) return;
      PlayerController.getInstance().mouseEnter();
    }
  }

  public static onSelectText(
    selection: Selection,
    elementId: string,
    isSelectPopup?: boolean,
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      if (!selection) {
        dispatch(CaptionsSelectionPopupActions.setSelection(null as any));
        dispatch(CaptionsSelectionPopupActions.setSelectResult(null));
        return false;
      }
      EventsRouter.trackEvent(Events.TARGET_CAPTION_SELECTED);

      const onPlay = async (): Promise<any> => {
        return PlayerController.getInstance().pausePlay(true)
      }
      await TargetCaptionsEffects.runSelectText(selection, null, elementId, isSelectPopup, true, onPlay);

    }
  }

  public static onDismissSelectText(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (document.body.classList.contains('onboarding-active')) return;

      SelectionUtil.removeWindowSelection();
      SelectionPopupEffects.dismissSelectText();
    }
  }

  public static onChangeActiveIndex(index: number) : AppThunk {
    return (
      dispatch,
      getState
    ) => {
      PhraseDetailsEffects.updateOnChangeActiveTargetIndex(index);
    }
  }

  public static onGetPhraseTitle(phraseId: number) : AppThunk {
    return (
      dispatch,
      getState
    ): string => {
      const TRIM_TRANSLATE_TOOLTIP = 80;
      if (phraseId) {
        let text = findVideoPhraseById(getState(), phraseId)?.translated || '';
        if (text.length > TRIM_TRANSLATE_TOOLTIP * 1.5) {
          text = text.slice(0, TRIM_TRANSLATE_TOOLTIP) + '...';          
        }
        return text;
        /*const contextPhrase = findVideoPhraseById(getState(), phraseId);
        if (contextPhrase?.wordPhraseId) {
          const phrase = findVideoPhraseById(getState(), contextPhrase?.wordPhraseId);
          return phrase?.translated || '';
        }*/
      }
      return '';
    }
  }

  public static onCheckLoadCaptions() : AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      /*const state = getState();
      const captions = getTargetCaptions(state);
      if (captions?.length < 1) {
        const extensionInstalled = await ExtensionInstallChecker.check();
        if (extensionInstalled) {
          const playerApi = await PlayerFactory.getPlayerApi();
          const videoId = getCurrentMovieKey(state);
          const groupId = getActiveGroupId(state);
          await dispatch(loadVideoEffect(videoId, playerApi, groupId));
        }
      }*/

    }
  }



}
